<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-change-work-shift :wsSelected="wsSelected" :reloadPage.sync="reloadPg"></modal-change-work-shift>

    <section>
      <page-header :headerName="'Turnos da Empresa'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/detalhes-da-empresa/' + this.$route.params.idCompany + '/' + this.$route.params.context"
                   :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- No Result -->
            <div v-if="!loading && !dataWorkShift.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum turno cadastrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataWorkShift.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de turnos ({{ dataWorkShift.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> ID</th>
                        <th> NOME</th>
                        <th> RemunerateTypeStr</th>
                        <th> ExtraordinaryPhaseStr</th>
                        <th> ToleranceType</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataWorkShift">
                        <th>{{ c.id }}</th>
                        <td>{{ c.name }}</td>
                        <td>{{ c.remunerateTypeStr }}</td>
                        <td>{{ c.extraordinaryPhaseStr }}</td>
                        <td>
                          {{ c.toleranceType }} -
                          <span v-if="c.toleranceType === 0">Não aplicar</span>
                          <span v-if="c.toleranceType === 1">Cada registro</span>
                          <span v-if="c.toleranceType === 2">Acumulada no dia</span>
                          <span v-if="c.toleranceType === 3">Cada registro e acumulada no dia</span>
                          <span v-if="c.toleranceType === 4">Youtility</span>
                          <span v-if="c.toleranceType === 5">Primeiro ponto e último</span>
                        </td>
                        <td>
                          <a v-on:click="openModalEditWs(c)" title="Editar">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </a>
                          <a v-bind:href="'/lista-de-dias-do-turno/' + companyId + '/' + c.id + '/2' + '/' + context"
                             title="Visualizar dias">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalChangeWorkShift from "../../modals/modalChangeWorkShift.vue";
import swal from 'sweetalert';

import {
  GET_WS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "list-all-ws",
  components: {
    topMenu,
    pageHeader,
    modalChangeWorkShift,
    fullLoading
  },
  data() {
    return {
      companyId: this.$route.params.idCompany,
      context: this.$route.params.context,
      reloadPg: 0,
      checkAll: false,
      checked: false,
      loading: false,
      failRequest: false,
      dataWorkShift: null,
      qtdWorkShift: 30,
      listFromUser: [],
      wsSelected: null
    }
  },
  methods: {
    getWorkShiftByCompany() {
      this.loading = true;

      let url = GET_WS + "?companyId=" + this.companyId;
      REQUEST_SERVICE.requestContext('GET', url, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_WS:", response.data);

        this.dataWorkShift = response.data;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    openModalEditWs(ws) {
      this.wsSelected = ws;
      this.wsSelected.context = this.context;
      $("#modalChangeWs").modal();
    }
  },
  beforeMount() {
    this.getWorkShiftByCompany();
  },
  watch: {
    reloadPg: function (val) {
      this.getWorkShiftByCompany();
    }
  }
}
</script>

<style lang="scss">
.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837d7d;
    border-bottom: 1px solid #bdb3b3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598dc;
    color: #ffffff;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/listAllWorkShift.vue